import { memo, ReactElement } from "react";

import ManagePositionCta from "./ManagePositionCta";
import { RaydiumContextType } from "../raydium/types";

type ManagePositionWrapperProps = {
    children: ReactElement;
    context: RaydiumContextType;
    actionType: ActionType;
};

export type ActionType = "deposit" | "withdraw" | "open";

const ManagePositionWrapper = memo(function ManagePositionWrapper({
    children,
    context,
    actionType
}: ManagePositionWrapperProps) {
    const { isActionTypeInitialized } = context;

    if (!isActionTypeInitialized || !isActionTypeInitialized.includes(actionType))
        return <ManagePositionCta context={context} actionType={actionType} />;

    return children;
});

export default ManagePositionWrapper;
